import React from "react";

//IMAGES
import CotalityLogo from '../../../image/CotalityLogo-footer.svg'

import './footer.css'

class Footer extends React.Component{

  constructor(props){
    super(props);

    //SERVICES
    this.trackCompanyInfo = this.props.SegmentAnalytics.trackCompanyInfo.bind(this)
  }

  redirectToURL(link, pageName) {
    this.trackCompanyInfo(pageName);
    window.open(link, "_blank", "noopener noreferrer");
  }

  render(){
    return (
      <footer className="footer" id="footer">
        <div className="container padding-30-0">
        <div className="footer-row row">
          <div id="footer-container" className="footer-column">
            <div className="row footer-terms margin-10">
              <p className="no-margin footer-links">
                &copy; 2025 CoreLogic NZ Limited t/as Cotality. <br className="line-break-768"/> All rights reserved.<br className="line-break-768" />
                <br className="line-break-992 line-break-574" />
                
              </p>
              <p className="no-margin footer-links">
                <a
                  className="footer-link"
                  id="privacy-policy"
                  onClick={() => {this.redirectToURL("https://www.cotality.com/nz/legal/privacy", "Privacy Policy")}}
                >
                  Privacy Policy
                </a>
                <br className="line-break-464" />
                <span className="divider-464">|</span>
                <a
                  className="footer-link"
                  id="product-terms"
                  onClick={() => {this.redirectToURL("https://www.cotality.com/nz/legal/terms-conditions", "Product Terms & Conditions")}}
                >
                  Product Terms & Conditions
                </a>
                <br className="line-break-768 line-break-464 line-break-465 " />
                <span className="divider-768 divider-464 divider-465">|</span>
                <a
                  className="footer-link"
                  id="website-terms"
                  onClick={() => {this.redirectToURL("https://www.cotality.com/nz/legal/website-terms-of-use", "Website Terms of Use")}}
                >
                  Website Terms of Use
                </a>
                <br className="line-break-992  line-break-618 line-break-464" />
                <span className="divider-992  divider-618 divider-464">|</span>
                <a
                  className="footer-link"
                  id="data-code-of-conduct"
                  onClick={() => {this.redirectToURL("https://www.cotality.com/nz/legal/data-code-of-conduct", "Data Code of Conduct")}}
                >
                  Data Code of Conduct
                </a>
                <br className="line-break-768 line-break-465 line-break-464" />
                <span className="divider-768 divider-465 divider-464">|</span>
                <a
                  className="footer-link"
                  id="disclaimer"
                  onClick={() => {this.redirectToURL("https://www.cotality.com/nz/legal/disclaimers", "Disclaimer")}}
                >
                  Disclaimer
                </a>
              </p>
            </div>
          </div>
          <div id="footer-logo-column" className="footer-column">
            <img src={CotalityLogo} alt="Core Logic" id="footer-logo"/>
          </div>
        </div>
      </div>
      </footer>
    )
  }
}

export default Footer;
